import _classCallCheck from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */

/**
 * Explicit error types.
 *
 * See the following link for more information about why the code includes
 * calls to setPrototypeOf:
 *
 * https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 */
// tslint:enable

/**
 * Equivalent of Python's AttributeError.
 */
export var AttributeError = /*#__PURE__*/function (_Error) {
  _inherits(AttributeError, _Error);

  function AttributeError(message) {
    var _this;

    _classCallCheck(this, AttributeError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AttributeError).call(this, message)); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), AttributeError.prototype);
    return _this;
  }

  return AttributeError;
}(_wrapNativeSuper(Error));
/**
 * Equivalent of Python's RuntimeError.
 */

export var RuntimeError = /*#__PURE__*/function (_Error2) {
  _inherits(RuntimeError, _Error2);

  function RuntimeError(message) {
    var _this2;

    _classCallCheck(this, RuntimeError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RuntimeError).call(this, message)); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this2)), RuntimeError.prototype);
    return _this2;
  }

  return RuntimeError;
}(_wrapNativeSuper(Error));
/**
 * Equivalent of Python's ValueError.
 */

export var ValueError = /*#__PURE__*/function (_Error3) {
  _inherits(ValueError, _Error3);

  function ValueError(message) {
    var _this3;

    _classCallCheck(this, ValueError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ValueError).call(this, message)); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this3)), ValueError.prototype);
    return _this3;
  }

  return ValueError;
}(_wrapNativeSuper(Error));
/**
 * Equivalent of Python's NotImplementedError.
 */

export var NotImplementedError = /*#__PURE__*/function (_Error4) {
  _inherits(NotImplementedError, _Error4);

  function NotImplementedError(message) {
    var _this4;

    _classCallCheck(this, NotImplementedError);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(NotImplementedError).call(this, message)); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this4)), NotImplementedError.prototype);
    return _this4;
  }

  return NotImplementedError;
}(_wrapNativeSuper(Error));
/**
 * Equivalent of Python's AssertionError.
 */

export var AssertionError = /*#__PURE__*/function (_Error5) {
  _inherits(AssertionError, _Error5);

  function AssertionError(message) {
    var _this5;

    _classCallCheck(this, AssertionError);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, message)); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this5)), AssertionError.prototype);
    return _this5;
  }

  return AssertionError;
}(_wrapNativeSuper(Error));
/**
 * Equivalent of Python's IndexError.
 */

export var IndexError = /*#__PURE__*/function (_Error6) {
  _inherits(IndexError, _Error6);

  function IndexError(message) {
    var _this6;

    _classCallCheck(this, IndexError);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(IndexError).call(this, message)); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this6)), IndexError.prototype);
    return _this6;
  }

  return IndexError;
}(_wrapNativeSuper(Error));